// test2657
(2657 && 0);
